import React from 'react'

type DraftModeBannerProps = {
  currentPath: string
}


export function DraftModeBanner({ currentPath }: DraftModeBannerProps) {
  const disableDraftHref = `/api/disable-draft?redirect=${encodeURIComponent(
    currentPath
  )}`

  return (
    <div
      role="status"
      className="fixed bottom-4 left-1/2 z-[10000] flex -translate-x-1/2 items-center gap-3 rounded-full bg-[#1f1f1f]/70 backdrop-blur-sm px-4 py-3 text-sm text-white shadow-[0_0.5rem_1.5rem_rgba(0,0,0,0.2)]"
    >
      <span className="whitespace-nowrap font-">Draft Mode aktiv</span>
      <a
        href={disableDraftHref}
        className="whitespace-nowrap font-semibold rounded-full bg-white px-3 py-1.5 text-[#1f1f1f] !no-underline hover:bg-error hover:text-white focus:!underline"
      >
        Beenden
      </a>
    </div>
  )
}
